import React, { useState, useRef } from 'react';

import { Popover, TableRow, TableCell, ButtonBase, Tooltip } from '@mui/material';
import Node from '../../../common/Node';
import TrplCheckbox from '../../../common/TrplControls/TrplCheckbox';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import DoneIcon from '@mui/icons-material/Done';
import FilterIcon from '@mui/icons-material/FilterList';

import Filters from '../../../common/Filters';
import CopyBtn from '../../../common/CopyBtn';

import moment from 'moment';
import ArrowTooltipCss from '../../../common/ArrowTooltipCss';

export default ({
  index,
  invite,
  classes,
  nodesData,
  accountsTbox,
  onEnableInvite,
  sendInvitation,
  setup_accounts,
  deleteInvitation,
}) => {
  if (!invite) return;
  const [showFiltersPopover, setShowFiltersPopover] = useState(false);

  const filterBtnRef = useRef(null);

  const enabled = `${!invite.is_enabled ? classes.op5 : '#fff'}`;

  const iId = setup_accounts && Object.values(setup_accounts).length
    && Object.values(setup_accounts).find(account => account.login === invite.email);

  return (
    <TableRow className={`${enabled}`} style={{ background: !invite.is_enabled ? '#eeecf8' : '' }}>
        <TableCell className={classes.tCell} style={{width: '10px'}}>
          {!invite.iid && !invite.is_expired &&
            <Tooltip
              title={invite.is_enabled ? "Disable" : "Enable"}
              placement="top"
              classes={{
                tooltip: classes.muiTooltip,
              }}
            >
              <div>
                <TrplCheckbox
                  disableRipple
                  style={{
                    marginLeft: '10px',
                    color: '#878787',
                    height: '24px',
                    width: '24px',
                  }}
                  checked={invite.is_enabled}
                  value={invite.is_enabled}
                  classes={{
                    root: classes.rstCheckboxGray,
                    label: classes.rstCheckboxLabel,
                  }}
                  onChange={(e) => {
                    if ((invite.iid > 0 && invite.is_enabled) || (!invite.iid || invite.iid === 0))
                    onEnableInvite(invite, e.target.checked, index);
                  }}
                />
              </div>
            </Tooltip>
          }
        </TableCell>

      <TableCell className={classes.tCell} style={{width: '160px'}}>
        {invite.role !== 0 ?
          <Node nodeId={invite.role} isLink size="sm" node={accountsTbox[invite.role]} />
        : null}
      </TableCell>

      <TableCell className={classes.tCell} style={{width: '160px'}}>
        {invite.iid && iId ?
          <Node nodeId={invite.iid} isLink size="sm" node={iId.individual} />
        : null}
      </TableCell>

      {invite.is_private &&
        <TableCell className={classes.tCell}>
          <div className={classes.nowrap}>
            {invite.email}
          </div>
        </TableCell>
      }

      <TableCell className={classes.tCell}>
        {invite.pre_state ?
          <React.Fragment>
            <div
              ref={filterBtnRef}
              style={{
                alignSelf: 'center',
                margin: '4px 0 0 0',
              }}
            >
              <FilterIcon
                //style={{ background: '#D6E5FF', borderRadius: '3px', color: '#4c4c4c', cursor: 'pointer' }}
                className={`${classes.actionIcon} ${'selected'}`}
                onClick={() => setShowFiltersPopover(true)}
              />
            </div>

            <Popover
              id={`filters-popover-personal`}
              anchorEl={filterBtnRef.current}
              open={showFiltersPopover}
              onClose={() => setShowFiltersPopover(false)}
              PaperProps={{
                style: {
                  marginTop: '10px',
                  overflow: 'visible',
                  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
                },
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <Filters
                mode='show'
                defaultBg={true}
                ancestor={invite.role}
                filterByNodeTitle={false}
                useChain
                loaded={true}
                nodes={nodesData}
                notEditableGraphTrigger
                graphTriggerAncestor={accountsTbox[invite.role]}
                initialFilters={invite.pre_state}
              />
            </Popover>
          </React.Fragment>
        : null}
      </TableCell>

      {invite.url &&
        <TableCell className={classes.tCell}>
          <div className={`${classes.nowrap} ${classes.fw} ${classes.flex}`}>
            <span>{invite.code}</span>
            {invite && invite.is_enabled && !invite.is_expired && invite.url ?
              <ArrowTooltipCss title="Copy to clipboard">
                <CopyBtn
                  text={invite.url}
                  copyIconStyles={{
                    marginLeft: '7px',
                    fontSize: '16px',
                  }}
                  />
              </ArrowTooltipCss>
            : null}
          </div>
        </TableCell>
      }

      {invite.time &&
      <TableCell className={classes.tCell}>
        <div className={classes.nowrap}>
          {moment(invite.time).format('MM/DD/YYYY HH:mm')}
        </div>
      </TableCell>
      }

      <TableCell className={classes.tCell}>
       {invite.iid ? null :
        invite.is_expired && !invite.iid ?
          <span style={{ display: 'flex', padding: '8px' }}>Expired</span>
        : invite.is_private && !invite.is_sent ?
          <ButtonBase
            disabled={!invite.is_enabled}
            onClick={() => sendInvitation(invite.code)}
            className={`${classes.btn} ${classes.btnNormal} ${classes.nowrap}`}
            style={{
              paddingLeft: '15px',
              paddingRight: '15px',
              textTransform: 'none',
            }}
          >
            Send invitation
          </ButtonBase>
        : invite.is_private && invite.is_sent ?
          <div className={`${classes.nowrap} ${classes.fw} ${classes.alignCenter}`}>
            <span>Sent</span>
            <DoneIcon
              style={{
                paddingLeft: '5px',
                color: '#1EB923',
                width: '18px'
              }}
              color="inherit"
              />
          </div>
        : null}
      </TableCell>

      <TableCell className={classes.tCell} style={{width: '30px'}}>
        <ButtonBase
          onClick={() => deleteInvitation(invite, index)}>
          <Tooltip
            title="Delete"
            placement="top"
            classes={{
              tooltip: classes.muiTooltip,
            }}
          >
            <DeleteIcon className={`${classes.tableRowBtn} ${classes.deleteBtnIcon}`} />
          </Tooltip>
        </ButtonBase>
      </TableCell>
    </TableRow>
  );
}
